export default class EmailTemplatePlaceholders {
    static readonly CompanyName = '{{COMPANY_NAME}}';
    static readonly RecruitmentName = '{{RECRUITMENT_NAME}}';
    static readonly ApplicantName = '{{APPLICANT_NAME}}';
    static readonly RecruiterName = '{{RECRUITER_NAME}}';
    static readonly FirstName = '{{FIRST_NAME}}';
    static readonly LastName = '{{LAST_NAME}}';
    static readonly Signature = '{{SIGNATURE}}';
}
